import { IMultimediaList } from '../Models/Multimedia/IMultimediaList';
import { IMultimediaFilterParams } from '../Models/Multimedia/IMultimediaFilterParams';
import { IMultimediaTheme } from '../Models/Multimedia/IMultimediaTheme';

const headers = new Headers();
headers.append('Accept-Language', document.querySelector('html')!.lang);
headers.append('Content-Type', 'application/json');

export const MultimediaService = {
    async getAllMultimedias(
        params: IMultimediaFilterParams,
        signal?: AbortSignal
    ): Promise<IMultimediaList> {
        const response = await fetch('/api/Multimedia/GetAllMultimedias', {
            method: 'POST',
            body: JSON.stringify(params),
            headers,
            signal,
        });
        const json = await response.json();
        return json;
    },

    async getAllThemes(): Promise<IMultimediaTheme[]> {
        const response = await fetch('/api/Multimedia/GetAllThemes', {
            headers,
        });
        return response.json();
    },
};
